import { Component, ContentChildren, Input, QueryList, ViewChild } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { MathOperation } from '../math-operation';
import { MathExpressionService } from './math-expression.service';

@Component({
    selector: 'ms-math-expression',
    templateUrl: './math-expression.component.html',
    styleUrls: ['./math-expression.component.scss'],
    providers: [MathExpressionService, DimensionsListenerDirective],
    hostDirectives: [DimensionsListenerDirective],
    standalone: false
})
export class MathExpressionComponent {
  @ContentChildren(MathOperation) operations: QueryList<MathOperation>;

  @Input() fontFamily?: string;

  @Input() fontWeight?: number;

  @Input() color?: string;

  @Input() operationsLength: number;

  outerStyle: Partial<CSSStyleDeclaration> = {};

  partsStyle: Partial<CSSStyleDeclaration> = {};

  private _elementRefSizes: null | { width: number; height: number } = null;

  private _partsRefSizes: null | { width: number; height: number } = null;

  @ViewChild('outerRef', { read: DimensionsListenerDirective })
    _outerDimensionsListenerDirective: DimensionsListenerDirective;

  @ViewChild('partsRef', { read: DimensionsListenerDirective })
    _partsDimensionsListenerDirective: DimensionsListenerDirective;

  constructor(private readonly _mathExpressionService: MathExpressionService) {}

  ngOnInit() {
    this._mathExpressionService.changes.next({
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      color: this.color,
      flex: undefined,
    });
  }

  ngAfterViewInit() {
    this._outerDimensionsListenerDirective.sizeChanges.subscribe((res) => {
      // if (res.width === this._elementRefSizes.width )
      this._elementRefSizes = res;
      this._mathExpressionService.availableSpace = res;
      this.updateSizes();
    });
    this._partsDimensionsListenerDirective.sizeChanges.subscribe((res) => {
      this._partsRefSizes = res;
      this.updateSizes();
    });
  }

  updateSizes() {
    if (this._elementRefSizes === null || this._partsRefSizes === null) return;

    this.partsStyle.height = this._elementRefSizes.height + 'px';
    this.partsStyle.width = this._elementRefSizes.width + 'px';

  }

  ngAfterContentInit() {
    // setTimeout(() => {
    //   this.updateSizes();
    // }, 1000);
    // console.log(this.operations);
    // this.operations.forEach((operation) => {
    //   if (this.fontFamily) operation.fontFamily = this.fontFamily;
    //   if (this.fontWeight) operation.fontWeight = this.fontWeight;
    //   if (this.color) operation.color = this.color;
    // });
  }
}
